import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  FullAuditOrderGuiDto,
  FullAuditOrderResponseDto,
  PatchDto,
  SplitEntity,
  TaskCtBatchCompletionDto,
} from '../../models/interfaces';
import { ApiService } from '@ps-gui/shared-core';
import { BehandlerListEntry } from '../../pages/erfassung-behandler-page/components/model/behandler-list-entry.interface';

interface DrgOverview {
  code: string;
  from: string;
  to: string;
}

/**
 * Summarized what 301-record data is already present in a proof, to be displayed
 * as a warning to the extraction user.
 */
export interface Proof301DataOverview {
  drgs: DrgOverview[];
  diagnoseCount: number;
  opsCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class PersonenschadenApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.psBackendUrl;
  }

  patchAudit(auditPatchDto: PatchDto, auditId: string): Observable<string> {
    return super.patch<string, PatchDto>(`audit/ct/${auditId}`, auditPatchDto);
  }

  splitProof(proofId: string, numberOfCopies: number): Observable<SplitEntity[]> {
    return super.post(`audit/${proofId}/split`, {
      numberOfCopies,
    });
  }

  get301DataSummary(proofId: string): Observable<Proof301DataOverview> {
    return super.get(`audit/${proofId}/301-data-overview`);
  }

  performFullAuditOrder(request: FullAuditOrderGuiDto): Observable<FullAuditOrderResponseDto> {
    return super.post('order/full-audit', request);
  }

  getBehandlersForTask(taskId: string): Observable<BehandlerListEntry[]> {
    return super.get(`digidesk/task/erstelle-zusammenfassung/behandlers/${taskId}`);
  }

  completeTaskCtBatch(request: TaskCtBatchCompletionDto): Observable<unknown> {
    return super.post(`digidesk/task/task-ct-batch/complete`, request);
  }
}
